import { AbstractTooltip as Tooltip } from "../ToolTip/ToolTip";

import styles from "./warningIcon.module.css";

interface WarningIconProps {
  visible: boolean;
  tooltipId: string;
  onClick?: () => void;
}

export default function WarningIcon({ visible, tooltipId, onClick: handleClick }: Readonly<WarningIconProps>) {
  if (!visible) {
    return null;
  }

  return (
    <>
      <button data-tooltip-id={tooltipId} onClick={handleClick} className={styles.warningIcon}>
        <i />
      </button>
      <Tooltip id={tooltipId} />
    </>
  );
}
